var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useReducer, useEffect } from 'react';
import { fetchProfile, fetchMyPermissions, } from '../requests';
import { useGlobalDispatch } from './useGlobal';
import { Header } from '../components';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { NetworkSearch } from '../components/NetworkSearch/NetworkSearch';
import { ShopDetails } from '../components/NetworkSearch/ShopDetails';
var ProfileStateContext = React.createContext(undefined);
var ProfileDispatchContext = React.createContext(undefined);
var initState = {
    staffId: null,
    firstName: null,
    lastName: null,
    profileImage: null,
    email: null,
    roles: [],
    isFetching: true,
    apps: [],
    relianceAccounts: [],
    birthDate: null,
    loginDate: null,
    country: null,
    fetchedStatus: null,
    searchValue: '',
};
function profileReducer(state, action) {
    switch (action.type) {
        case 'fetching': {
            return __assign(__assign({}, initState), { isFetching: true });
        }
        case 'set': {
            return __assign(__assign(__assign({}, state), action.payload), { isFetching: false });
        }
        case 'set videoViews': {
            return __assign(__assign({}, state), { videoViews: action.payload });
        }
        case 'set search value': {
            return __assign(__assign({}, state), { searchValue: action.payload });
        }
        default: {
            throw new Error("Unhandled action type");
        }
    }
}
function ProfileProvider(_a) {
    var children = _a.children, allowedRoles = _a.allowedRoles;
    var _b = useReducer(profileReducer, initState), state = _b[0], dispatch = _b[1];
    return (_jsx(ProfileStateContext.Provider, __assign({ value: state }, { children: _jsx(ProfileDispatchContext.Provider, __assign({ value: dispatch }, { children: _jsx(InitProfileProvider, __assign({ allowedRoles: allowedRoles }, { children: _jsxs(Router, { children: [children, _jsx(Route, __assign({ path: '/network-search/shop/:id' }, { children: _jsx(ShopDetails, {}, void 0) }), void 0),
                        _jsx(Route, __assign({ exact: true, path: '/network-search' }, { children: _jsx(NetworkSearch, {}, void 0) }), void 0)] }, void 0) }), void 0) }), void 0) }), void 0));
}
function InitProfileProvider(_a) {
    var children = _a.children, allowedRoles = _a.allowedRoles;
    var profile = useProfileState();
    var dispatch = useProfileDispatch();
    var globalDispatch = useGlobalDispatch();
    useEffect(function () {
        getProfile();
    }, []);
    // const [displayIntroVideo, setDisplayIntroVideo] = useState(false)
    function getProfile() {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _b, fetchedProfile, permissions, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        // set loader
                        globalDispatch({ type: 'set global loading', payload: true });
                        return [4 /*yield*/, Promise.all([
                                fetchProfile(),
                                fetchMyPermissions(),
                            ])];
                    case 1:
                        _b = _c.sent(), fetchedProfile = _b[0], permissions = _b[1];
                        // stop loader
                        globalDispatch({ type: 'set global loading', payload: false });
                        dispatch({
                            type: 'set',
                            payload: __assign(__assign({}, fetchedProfile), { permissions: permissions, fetchedStatus: 200 }),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _c.sent();
                        if (((_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.status) !== 401) {
                            throw error_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    if (profile.isFetching) {
        return null;
    }
    else if (allowedRoles &&
        !profile.roles.some(function (role) { return allowedRoles.includes(role.name); })) {
        return (_jsxs(React.Fragment, { children: [_jsx(Header, { productName: 'World', cmsCourseId: -1, productLogo: '/global/static/logos/world.svg', darkModeLogo: '/global/static/logos/world.svg' }, void 0),
                _jsx("div", __assign({ style: {
                        display: 'flex',
                        height: '90vh',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 20,
                    } }, { children: "403 don't have access" }), void 0)] }, void 0));
    }
    return _jsx(React.Fragment, { children: children }, void 0);
}
function useProfileState() {
    var context = React.useContext(ProfileStateContext);
    if (context === undefined) {
        throw new Error('useProfileState must be used within a ProfileProvider');
    }
    return context;
}
function useProfileDispatch() {
    var context = React.useContext(ProfileDispatchContext);
    if (context === undefined) {
        throw new Error('useProfileDispatch must be used within a ProfileProvider');
    }
    return context;
}
export { ProfileProvider, useProfileState, useProfileDispatch };
